"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonyName_1 = require("@/common/colonies/ColonyName");
const ColonyRow_vue_1 = require("@/client/components/colonies/ColonyRow.vue");
const ColonyTradeRow_vue_1 = require("@/client/components/colonies/ColonyTradeRow.vue");
const ClientColonyManifest_1 = require("@/client/colonies/ClientColonyManifest");
const ColonyBenefit_1 = require("@/common/colonies/ColonyBenefit");
const Resource_1 = require("@/common/Resource");
const i18n_1 = require("@/client/directives/i18n");
exports.default = vue_1.default.extend({
    name: 'colony',
    props: {
        colony: {
            type: Object,
        },
        active: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        ColonyRow: ColonyRow_vue_1.default,
        ColonyTradeRow: ColonyTradeRow_vue_1.default,
    },
    computed: {
        metadata() {
            return (0, ClientColonyManifest_1.getColony)(this.colony.name);
        },
        colonyResourceClass() {
            const resource = this.metadata.cardResource;
            return resource?.toString()?.toLowerCase() ?? '';
        },
        recedeIfInactive() {
            return this.active === false ? 'inactiveColony' : '';
        },
        backgroundClass() {
            return this.colony.name.replace(' ', '-') + '-background';
        },
        tooltip() {
            const descriptions = [this.metadata.build, this.metadata.trade, this.metadata.colony].map((b) => b.description);
            const titles = ['Build Colony bonus', 'Trade bonus', 'Colony bonus'].map(i18n_1.translateText);
            return `${titles[0]}: ${(0, i18n_1.translateText)(descriptions[0])}
${titles[1]}: ${(0, i18n_1.translateText)(descriptions[1])}
${titles[2]}: ${(0, i18n_1.translateText)(descriptions[2])}`;
        },
        ColonyName() {
            return ColonyName_1.ColonyName;
        },
        ColonyBenefit() {
            return ColonyBenefit_1.ColonyBenefit;
        },
        Resource() {
            return Resource_1.Resource;
        },
    },
});
